import {
  Box,
  Button,
  Text
} from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import styled from 'styled-components'

export const BtnPill = styled(Box)`
  border-radius: 9999px;
  padding: 6px 10px;
  cursor: pointer;
  transition: background 0.3s;
  display: ${({ shouldBeDisabled }) => (shouldBeDisabled ? 'block' : 'flex')};
  overflow: hidden;
  align-items: center;
  background-color: ${({ shouldBeDisabled }) => (shouldBeDisabled ? COLORS.gray_op8 : COLORS.gold)};
  pointer-events: ${({ shouldBeDisabled }) => (shouldBeDisabled ? 'none' : 'auto')};

  :hover {
    background: ${COLORS.gold_hover};
  }
`

export const DeletePopupBtn = styled(Button)`
  border-radius: 9999px !important;
  padding: 7.5px;
  cursor: pointer;
  transition: 0.5s;
  width: 80px;
  height: 35px !important;
  font-weight: 500 !important;
  font-size: 14px !important;

  @media (max-width: 473px) {
    font-size: 12.5px !important;
    width: 60px !important;
  }

  @media (max-width: 380px) {
    font-size: 12px !important;
    width: 50px !important;
  }

  :hover {
    background: ${COLORS.gold_hover};
  }
`

export const DeletePopupText = styled(Text)`
  color: rgb(253, 246, 243);
  font-size: 15px !important;

  @media (max-width: 473px) {
    font-size: 13.5px !important;
  }

  @media (max-width: 380px) {
    font-size: 13px !important;
  }
`
